import { IFeedback, ITranscriptMessage } from './types';

/**
 * Pure transcript helpers shared by the hook and its tests.
 * The backend names the answer it just stored in `turn_complete.message_id`;
 * the panel pins that id on the newest assistant message so it can be rated.
 */
export const tagLastAssistantMessage = (messages: ITranscriptMessage[], id?: string | null): ITranscriptMessage[] => {
    if (!id) return messages;
    for (let i = messages.length - 1; i >= 0; i -= 1) {
        if (messages[i].role === 'assistant') {
            const next = messages.slice();
            next[i] = { ...messages[i], id };
            return next;
        }
    }
    return messages;
};

export const withFeedback = (messages: ITranscriptMessage[], id: string, feedback: IFeedback | null): ITranscriptMessage[] => {
    for (let i = messages.length - 1; i >= 0; i -= 1) {
        if (messages[i].id === id) {
            const next = messages.slice();
            next[i] = { ...messages[i], feedback };
            return next;
        }
    }
    return messages;
};
